import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.array.filter.js";
export default function (_ref) {
  var req = _ref.req,
    $axios = _ref.$axios;
  var _ref2 = req || {},
    _ref2$header = _ref2.header,
    header = _ref2$header === void 0 ? {} : _ref2$header;
  var xMdM = Object.entries(header).filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      key = _ref4[0];
    return /^x-mdm-/i.test(key);
  });
  $axios.setHeader('correlation-id', header['correlation-id']);
  $axios.setHeader('mdm-client-ip', header['mdm-client-ip']);
  xMdM.forEach(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      key = _ref6[0],
      value = _ref6[1];
    return $axios.setHeader(key, value);
  });
}